import _ from 'lodash'
import API from '../../assets/js/libs/API'
import { SET_SERVICE_LIST } from './mutation-types'
export default {
  fetchServiceList({ commit }) {
    return API.get(`customerize/list`)
      .then((res) => res.result.serviceList)
      .then((result) => {
        commit(SET_SERVICE_LIST, result)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  // fetchManagerInfo({ dispatch }, id) {
  //   return managerService.getManagerInfo(id)
  //     .then(res => res.result)
  //     .then(result => {
  //       dispatch('setSelectedManagerInfo', _.cloneDeep(result));
  //       dispatch('setBackupManagerInfo', _.cloneDeep(result));
  //       return result;
  //     })
  //     .catch(err => console.log(err));
  // },
  // putSelectedManagerInfo({ getters, dispatch }, id) {
  //   return managerService.updateUserInfo(id, getters.getSelectedManagerInfo)
  //     .then(res => {
  //       dispatch(
  //         'setBackupManagerInfo',
  //         _.cloneDeep(getters.getSelectedManagerInfo),
  //       );
  //       return res;
  //     })
  //     .catch(err => err);
  // },
  // setSelectedManagerInfo({ commit }, managerInfo) {
  //   commit(SET_SELECTED_MANAGER_INFO, managerInfo);
  // },
  // setBackupManagerInfo({ commit }, managerInfo) {
  //   commit(SET_BACKUP_MANAGER_INFO, managerInfo);
  // },
  // restoreSelectedManagerInfo({ dispatch, state }) {
  //   dispatch(
  //     'setSelectedManagerInfo',
  //     _.cloneDeep(state.backupManagerInfo),
  //   );
  // },
  // setSelectedManagerDepartment({ commit }, department) {
  //   commit(SET_SELECTED_MANAGER_DEPARTMENT, department);
  // },
  // setSelectedManagerEmail({ commit }, email) {
  //   commit(SET_SELECTED_MANAGER_EMAIL, email);
  // },
  // setSelectedManagerNote({ commit }, note) {
  //   commit(SET_SELECTED_MANAGER_NOTE, note);
  // },
  // setSelectedManagerPhone({ commit }, phone) {
  //   commit(SET_SELECTED_MANAGER_PHONE, phone);
  // },
  // setSelectedManagerPositionId({ commit }, positionId) {
  //   commit(SET_SELECTED_MANAGER_POSITION_ID, positionId);
  // },
  // setSelectedManagerServiceNumber({ commit }, serviceNumber) {
  //   commit(SET_SELECTED_MANAGER_NUMBER, serviceNumber);
  // },
}



// WEBPACK FOOTER //
// ./src/store/serviceStore/actions.js